// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file morfi/v1/wallet.proto (package morfi.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file morfi/v1/wallet.proto.
 */
export const file_morfi_v1_wallet: GenFile = /*@__PURE__*/
  fileDesc("ChVtb3JmaS92MS93YWxsZXQucHJvdG8SCG1vcmZpLnYxImgKGVdhbGxldFF1b3RlQmFsYW5jZUNoYW5nZWQSEwoLc2VxdWVuY2VfaWQYASABKAwSDgoGd2FsbGV0GAIgASgJEhIKCnF1b3RlX21pbnQYAyABKAkSEgoKYmFsYW5jZV9kNhgEIAEoBGIGcHJvdG8z");

/**
 * Transaction-final classic-SPL USDC balance for one registered wallet.
 *
 * @generated from message morfi.v1.WalletQuoteBalanceChanged
 */
export type WalletQuoteBalanceChanged = Message<"morfi.v1.WalletQuoteBalanceChanged"> & {
  /**
   * @generated from field: bytes sequence_id = 1;
   */
  sequenceId: Uint8Array;

  /**
   * @generated from field: string wallet = 2;
   */
  wallet: string;

  /**
   * @generated from field: string quote_mint = 3;
   */
  quoteMint: string;

  /**
   * @generated from field: uint64 balance_d6 = 4;
   */
  balanceD6: bigint;
};

/**
 * Describes the message morfi.v1.WalletQuoteBalanceChanged.
 * Use `create(WalletQuoteBalanceChangedSchema)` to create a new message.
 */
export const WalletQuoteBalanceChangedSchema: GenMessage<WalletQuoteBalanceChanged> = /*@__PURE__*/
  messageDesc(file_morfi_v1_wallet, 0);

